export class LineChartGMBModel {
  constructor() {
    this.chart = null;
    this._chartConfig = null;
  }

  makeChart(chartConfig) {
    this._setChartConfig(chartConfig);
    this._setChartConfigAsChart();
    this._setChartData();
    this._setChartOptions();
    this._setChartSum();
    this._setChartPercentage();
  }

  returnChart() {
    return this.chart;
  }

  _setChartConfig(chartConfig) {
    this._chartConfig = chartConfig;
  }

  _setChartConfigAsChart() {
    this.chart = this._chartConfig;
  }

  _setChartData() {
    if (this.chart.relative) {
      this.chart.data = this.chart.relatedChartsData
        .map(relatedChartData => relatedChartData.conversionValues)
        .flat();
    } else {
      this.chart.data = this.chart.relatedChartsData
        .map(relatedChartData => relatedChartData.values)
        .flat();
    }
  }

  _formatNumber(value) {
    if (typeof value === "string" || value instanceof String) return value;
    return new Intl.NumberFormat("fr-FR").format(value);
  }

  _setChartOptions() {
    const vm = this;

    this.chart.options = {
      scales: {
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              return data["labels"][tooltipItem[0]["index"]];
            },
            label: function(tooltipItem, data) {
              return vm._formatNumber(
                data["datasets"][0]["data"][tooltipItem["index"]]
              );
            }
          }
        },
        xAxes: [
          {
            type: "time",
            time: {
              unit: this.chart.relatedChartsData[0].groupBy
            }
          }
        ]
      }
    };
  }

  _setChartSum() {
    this.chart.sum = this.chart.relatedChartsData
      .map(relatedChartData => relatedChartData.sum)
      .reduce((a, b) => a + b, 0)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  _setChartPercentage() {
    let chartsPercentage;
    if (this.chart.relative) {
      chartsPercentage = this.chart.relatedChartsData.map(
        relatedChartData => relatedChartData.conversionPeriodPercentageDiff
      );
    } else {
      chartsPercentage = this.chart.relatedChartsData.map(
        relatedChartData => relatedChartData.periodPercentageDiff
      );
    }
    chartsPercentage = chartsPercentage.filter(
      percentage => typeof percentage !== "undefined"
    );

    this.chart.percentage =
      chartsPercentage.length > 0
        ? Math.round(
            chartsPercentage.reduce((a, b) => a + b, 0) /
              this.chart.relatedChartsData.length
          )
        : null;
  }
}
